const defaultComparator = (aEl, bEl) => aEl.id == bEl.id;

/**
 * The elements of a that match some element of b  (using the comparator).
 * Default comparator is (aEl, bEl) => aEl.id == bEl.id
 * @param {Array} a
 * @param {Array} b
 * @param {Function} comparator A function comparing properties of a with properties of B. Most common use case: (aEl, bEl) => aEl.id == bEl.id
 * @returns {Array} The elements of a matching some element of b
 */
export const intersect = (a, b, comparator = defaultComparator) =>
  a.filter((aEl) => b.some((bEl) => comparator(aEl, bEl)));

/**
 * The elements of a that do NOT match b (using the comparator).
 * Default comparator is (aEl, bEl) => aEl.id == bEl.id
 * @param {Array} a
 * @param {Array} b
 * @param {Function} comparator
 * @returns {Array} the elements of a not matching b
 */
export const diff = (a, b, comparator = defaultComparator) =>
  a.filter((aEl) => !b.some((bEl) => comparator(aEl, bEl)));

/**
 * only works with arrays of primitive values
 * @param {Array} array
 **/
export const dedupSimple = (array) => [...new Set(array)];

export const dedup = (array, comparator = defaultComparator) =>
  array.reduce((acc, el) => {
    if (!acc.some((accEl) => comparator(el, accEl))) {
      acc.push(el);
    }
    return acc;
  }, []);

export function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}
/**
 * Checks if two arrays are equal (shallow comparison).
 * @param {Array} array1
 * @param {Array} array2
 * @returns {boolean} True if arrays are equal, false otherwise
 */
export const arraysEqual = (array1, array2) => {
  if (array1.length !== array2.length) return false;
  return array1.every((value, index) => value === array2[index]);
};
